/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type ApplicationResponseStatus =
    (typeof ApplicationResponseStatus)[keyof typeof ApplicationResponseStatus];

export const ApplicationResponseStatus = {
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    NOT_STARTED: 'NOT_STARTED'
} as const;
